import type { TabBarMenuTabType } from "@crescentapplications/react-ui";

const tabBarMenuTabs: TabBarMenuTabType[] = [
  {
    id: "profile",
    title: { ar: "الأساسيات", en: "Profile" },
    icon: "user",
    iconActive: "user-solid",
    to: "/#profile",
  },
  {
    id: "lineage",
    title: { ar: "النسب", en: "Lineage" },
    icon: "three-users",
    iconActive: "three-users",
    to: "/#lineage",
  },
  {
    id: "education",
    title: { ar: "الدراسة", en: "Education" },
    icon: "contract",
    iconActive: "contract-solid",
    to: "/#education",
  },
  {
    id: "work",
    title: { ar: "العمل", en: "Work" },
    icon: "building",
    iconActive: "building-solid",
    to: "/#work",
  },
  {
    id: "volunteering",
    title: { ar: "التطوع", en: "Volunteering" },
    icon: "objects",
    iconActive: "objects-solid",
    to: "/#volunteering",
  },
];

export default tabBarMenuTabs;
